import { render, staticRenderFns } from "./TotpResetDialog.vue?vue&type=template&id=24975681&scoped=true&"
import script from "./TotpResetDialog.vue?vue&type=script&lang=js&"
export * from "./TotpResetDialog.vue?vue&type=script&lang=js&"
import style0 from "./TotpResetDialog.vue?vue&type=style&index=0&id=24975681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24975681",
  null
  
)

export default component.exports